(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["competitions-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.competitions-hero__bg video').forEach(function(video) {
    video.muted = true;
    video.play().catch(function() {});
    video.addEventListener('playing', function() {
      var poster = video.closest('.competitions-hero__bg')?.querySelector('.competitions-hero__bg-poster');
      if (poster) poster.classList.add('is-hidden');
    });
  });

  document.querySelector('.js-scroll-to-next')?.addEventListener('click', function(e) {
    e.preventDefault();
    const heroSection = document.querySelector('.competitions-hero')?.closest('.shopify-section');
    const nextSection = heroSection?.nextElementSibling;
    if (nextSection) {
      const top = nextSection.getBoundingClientRect().top + window.scrollY - 160;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const el = document.currentScript.closest
      ? document.currentScript.previousElementSibling
      : null;

    const section = document.querySelector('.countdown[data-end]');
    if (!section) return;

    // Support multiple countdown sections on the same page
    document.querySelectorAll('.countdown[data-end]').forEach(function (section) {
      const endDate = new Date(section.dataset.end);
      if (isNaN(endDate)) return;

      const daysEl     = section.querySelector('[data-days]');
      const hoursEl    = section.querySelector('[data-hours]');
      const minutesEl  = section.querySelector('[data-minutes]');
      const secondsEl  = section.querySelector('[data-seconds]');

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function tick() {
        const diff = endDate - Date.now();

        if (diff <= 0) {
          daysEl.textContent    = '00';
          hoursEl.textContent   = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          return;
        }

        const days    = Math.floor(diff / 86400000);
        const hours   = Math.floor((diff % 86400000) / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);

        daysEl.textContent    = pad(days);
        hoursEl.textContent   = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);

        setTimeout(tick, 1000);
      }

      tick();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq .item__question').forEach(function(question) {
    question.addEventListener('click', function() {
      var item = question.closest('.list__item');
      var list = item.closest('.content__list');
      var isOpen = item.classList.contains('list__item--open');
      list.querySelectorAll('.list__item').forEach(function(other) {
        other.classList.remove('list__item--open');
      });
      if (!isOpen) item.classList.add('list__item--open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const btnMenu = document.querySelector('.js-btn-menu');
  const menu    = document.querySelector('.js-menu');

  btnMenu?.addEventListener('click', () => {
    const isOpen = menu.classList.toggle('active');
    btnMenu.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero__bg video').forEach(function(video) {
    video.muted = true;
    video.play().catch(function() {});
    video.addEventListener('playing', function() {
      var poster = video.closest('.hero__bg')?.querySelector('.hero__bg-poster');
      if (poster) poster.classList.add('is-hidden');
    });
  });

  const scrollBtn = document.querySelector('.js-scroll-down');
  if (scrollBtn) {
    function scrollToNext() {
      const heroSection = scrollBtn.closest('.shopify-section');
      const nextSection = heroSection?.nextElementSibling;
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
    scrollBtn.addEventListener('click', scrollToNext);
    scrollBtn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') scrollToNext();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-competitions"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.countdown__timer[data-countdown]').forEach(function(timer) {
    var end = new Date(timer.dataset.countdown).getTime();

    function update() {
      var now = Date.now();
      var diff = end - now;

      if (diff <= 0) {
        timer.closest('.item__countdown').style.display = 'none';
        return;
      }

      var days    = Math.floor(diff / 86400000);
      var hours   = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      timer.querySelector('[data-days]').textContent    = String(days).padStart(2, '0');
      timer.querySelector('[data-hours]').textContent   = String(hours).padStart(2, '0');
      timer.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      timer.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
    }

    update();
    setInterval(update, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // ── Accordion ──
  document.querySelectorAll('.item__summary').forEach(function(summary) {
    summary.addEventListener('click', function() {
      summary.closest('.accordion__item').classList.toggle('accordion__item--open');
    });
  });

  // ── Gallery thumbnails (product page) ──
  const mainImg = document.getElementById('product-gallery-main');
  document.querySelectorAll('.js-gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.srcset = thumb.dataset.srcset || '';
      }
      document.querySelectorAll('.js-gallery-thumb').forEach(t => t.classList.remove('thumbnails__item--active'));
      thumb.classList.add('thumbnails__item--active');
    });
  });

  // ── Quantity +/- (max 10) ──
  const qtyInput = document.getElementById('quantity-input');
  if (qtyInput) {
    document.querySelector('.quantity__btn--minus')?.addEventListener('click', () => {
      if (parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1;
    });
    document.querySelector('.quantity__btn--plus')?.addEventListener('click', () => {
      if (parseInt(qtyInput.value) < 10) qtyInput.value = parseInt(qtyInput.value) + 1;
    });
  }

  // ── Entry modal ──
  const entryModal   = document.querySelector('.js-entry-modal');
  const answerInput  = document.getElementById('js-answer-input');
  const realSubmit   = document.getElementById('js-real-submit');
  const proceedBtn   = document.querySelector('.js-proceed-checkout');
  const ageConfirm   = document.querySelector('.js-age-confirm');
  let selectedAnswer = null;

  function checkProceedReady() {
    const ready = selectedAnswer !== null && ageConfirm?.checked;
    if (proceedBtn) proceedBtn.disabled = !ready;
  }

  document.querySelector('.js-open-entry-modal')?.addEventListener('click', () => {
    if (!entryModal) return;
    selectedAnswer = null;
    if (answerInput) answerInput.value = '';
    if (ageConfirm) ageConfirm.checked = false;
    document.querySelectorAll('.js-answer-btn').forEach(b => b.classList.remove('answer__btn--selected'));
    if (proceedBtn) proceedBtn.disabled = true;
    entryModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  });

  document.querySelector('.entry-modal__backdrop')?.addEventListener('click', () => {
    entryModal?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  });

  document.querySelector('.modal__close')?.addEventListener('click', () => {
    entryModal?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  });

  document.querySelectorAll('.js-answer-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.js-answer-btn').forEach(b => b.classList.remove('answer__btn--selected'));
      btn.classList.add('answer__btn--selected');
      selectedAnswer = btn.dataset.answer;
      if (answerInput) answerInput.value = selectedAnswer;
      checkProceedReady();
    });
  });

  ageConfirm?.addEventListener('change', checkProceedReady);

  proceedBtn?.addEventListener('click', () => {
    if (!selectedAnswer || !ageConfirm?.checked) return;
    realSubmit?.click();
  });

  // ── Fullscreen galleries (Swiper, lazy-loaded) ──
  function loadScript(src) {
    return new Promise(resolve => {
      if (document.querySelector('script[src="' + src + '"]')) return resolve();
      const s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      document.head.appendChild(s);
    });
  }

  function loadStyle(href) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    const l = document.createElement('link');
    l.rel  = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  function preloadNearby(swiper, amount) {
    const slides = swiper.slides;
    const current = swiper.activeIndex;
    for (let i = 1; i <= amount; i++) {
      [current + i, current - i].forEach(idx => {
        if (idx < 0 || idx >= slides.length) return;
        const img = slides[idx].querySelector('img');
        if (img && img.getAttribute('loading') === 'lazy') img.removeAttribute('loading');
      });
    }
  }

  function createGallery(overlaySelector, mainId, thumbsId) {
    const overlay = document.querySelector(overlaySelector);
    if (!overlay) return;
    let ready = false;

    function init() {
      if (ready) return;
      const thumbsSwiper = new Swiper('#' + thumbsId, {
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
      });
      new Swiper('#' + mainId, {
        spaceBetween: 10,
        navigation: { nextEl: overlay.querySelector('.swiper-button-next'), prevEl: overlay.querySelector('.swiper-button-prev') },
        thumbs: { swiper: thumbsSwiper },
        on: {
          init: function() { preloadNearby(this, 3); },
          slideChange: function() { preloadNearby(this, 3); },
        },
      });
      ready = true;
    }

    function open() {
      loadStyle('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css');
      loadScript('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js').then(() => {
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        init();
      });
    }

    function close() {
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    return { open, close, overlay };
  }

  const mainGallery    = createGallery('.js-gallery-overlay',         'gallery-swiper-main',          'gallery-swiper-thumbs');
  const indoorGallery  = createGallery('.js-gallery-overlay-indoor',  'gallery-swiper-indoor-main',   'gallery-swiper-indoor-thumbs');
  const outdoorGallery = createGallery('.js-gallery-overlay-outdoor', 'gallery-swiper-outdoor-main',  'gallery-swiper-outdoor-thumbs');

  document.querySelectorAll('.js-gallery-open').forEach(btn => btn.addEventListener('click', () => mainGallery?.open()));
  document.querySelectorAll('.js-gallery-indoor-open').forEach(btn => btn.addEventListener('click', () => indoorGallery?.open()));
  document.querySelectorAll('.js-gallery-outdoor-open').forEach(btn => btn.addEventListener('click', () => outdoorGallery?.open()));

  document.querySelector('.js-gallery-close')?.addEventListener('click', () => mainGallery?.close());
  document.querySelector('.js-gallery-indoor-close')?.addEventListener('click', () => indoorGallery?.close());
  document.querySelector('.js-gallery-outdoor-close')?.addEventListener('click', () => outdoorGallery?.close());

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (entryModal?.getAttribute('aria-hidden') === 'false') {
      entryModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      return;
    }
    [mainGallery, indoorGallery, outdoorGallery].forEach(g => {
      if (g?.overlay.getAttribute('aria-hidden') === 'false') g.close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var GAP = 20;

    function initSlider(el) {
      var viewport = el.querySelector('[data-testimonials-viewport]') || el.closest('.testimonials__slider').querySelector('.testimonials__viewport');
      var track    = el.querySelector('[data-testimonials-track]');
      var cards    = Array.from(track.querySelectorAll('[data-testimonials-card]'));
      var prevBtn  = el.querySelector('[data-testimonials-prev]');
      var nextBtn  = el.querySelector('[data-testimonials-next]');

      if (!cards.length) return;

      var current = 0;

      function visible() { return window.innerWidth < 768 ? 1 : 3; }
      function maxIdx()  { return Math.max(0, cards.length - visible()); }

      function cardW() {
        var n = visible();
        return (viewport.offsetWidth - GAP * (n - 1)) / n;
      }

      function update() {
        var w = cardW();
        cards.forEach(function(c) { c.style.width = w + 'px'; });
        track.style.transform = 'translateX(-' + (current * (w + GAP)) + 'px)';
        prevBtn.disabled = current === 0;
        nextBtn.disabled = current >= maxIdx();
      }

      prevBtn.addEventListener('click', function() {
        if (current > 0) { current--; update(); }
      });

      nextBtn.addEventListener('click', function() {
        if (current < maxIdx()) { current++; update(); }
      });

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          current = Math.min(current, maxIdx());
          update();
        }, 100);
      });

      update();
    }

    function boot() {
      document.querySelectorAll('[data-testimonials-slider]').forEach(function(el) {
        initSlider(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
